import { jwtDecode } from 'jwt-decode';
import { DecodedToken } from '../types/RoleType';
import { SelectOption } from '../types/common';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';

dayjs.extend(utc);
dayjs.extend(timezone);

export function decodeJwtToken(token: string): DecodedToken {
  try {
    const decoded = jwtDecode<DecodedToken>(token);
    return decoded;
  } catch (error) {
    console.error(error);
    throw new Error("Invalid or malformed JWT token");
  }
}
export const formatCurrency = (amount: number) => {
  return new Intl.NumberFormat('en-IN', {
    style: 'currency',
    currency: 'INR',
    maximumFractionDigits: 2,
  }).format(amount);
};


export const formatTime = (time: string) => {
  return (time && new Date(`1970-01-01T${time}`).toLocaleTimeString('en-US', {
    hour: 'numeric',
    minute: '2-digit',
    hour12: true,
  }));
};

export function formatOffsetDateTimeToLocal(dateWithOffset?: string, outputFormat: string = 'YYYY-MM-DD HH:mm:ss'): string {
  // Example input: "15-05-2025 17:49:44 +05:30"
  // Parse the UTC timestamp
  const parsedTime = dayjs(dateWithOffset, 'DD-MM-YYYY HH:mm:ss Z');
  // Convert to local time
  const localTime = parsedTime.local();

  // Format the local time
  return localTime.format(outputFormat);
}

export const generatePath = (template: string, params: Record<string, string | number>) => {
  return Object.entries(params).reduce((path, [key, value]) => {
    return path.replace(`:${key}`, encodeURIComponent(value.toString()));
  }, template);
};


export const holidayTypeOptions : SelectOption[] = [
  { id: 1, value: 'public', label: 'Public' },
  { id: 2, value: 'institute', label:'Institute'},
  { id: 3, value: 'optional', label: 'Optional' },
];

export const holidayDurationOptions: SelectOption[] = [
  { id: 1, value: 'full', label: 'Full Day' },
  { id: 2, value: 'half', label: 'Half Day' },
];

export const leaveTypeOptions: SelectOption[] = [
  { id: 1, value: 'Sick Leave', label: 'Sick Leave' },
  { id: 2, value: 'Casual Leave', label: 'Casual Leave' },
  { id: 2, value: 'Optional Leave', label: 'Optional Leave' },
]

export const genderOptions: SelectOption[] = [
  { id: 1, value: "male", label: "Male" },
  { id: 2, value: "female", label: "Female" },
  { id: 3, value: "other", label: "Other" },
  { id: 4, value: "prefer_not_to_say", label: "Prefer not to say" }
];
export const bloodGroupOptions: SelectOption[] = [
  { id: 1, value: "O+", label: "O+" },
  { id: 2, value: "O-", label: "O-" },
  { id: 3, value: "A+", label: "A+" },
  { id: 4, value: "A-", label: "A-" },
  { id: 5, value: "B+", label: "B+" },
  { id: 6, value: "B-", label: "B-" },
  { id: 7, value: "AB+", label: "AB+" },
  { id: 8, value: "AB-", label: "AB-" },
];
export const maritalStatusOptions: SelectOption[] = [
  { id: 1, value: "single", label: "Single" },
  { id: 2, value: "Married", label: "Married" },
  { id: 3, value: "prefer_not_to_say", label: "Prefer not to say" }
]
export const religionOptions: SelectOption[] = [
  { id: 1, value: "hinduism", label: "Hinduism" },
  { id: 2, value: "islam", label: "Islam" },
  { id: 3, value: "christianity", label: "Christianity" },
  { id: 4, value: "others", label: "Others" }
]
export const casteOptions: SelectOption[] = [
  { id: 1, value: "general", label: "General" },
  { id: 2, value: "OBC", label: "OBC"},
  { id: 3, value: "SC", label: "SC"},
  { id: 4, value: "ST", label: "ST" },
  { id: 5, value: "minority", label: "Minority" },
]
export const hostelRoleOptions: SelectOption[] = [
  { id: 1, value: 'Hostel Warden', label: 'Hostel Warden' },
  { id: 2, value: 'Security Personnel', label:'Security Personnel'},
  { id: 3, value: 'Housekeeping Staff', label:'Housekeeping Staff'},
]

export const getGradeColor = (grade: string): 'success' | 'info' | 'warning' | 'error' | 'default' => {
  if (grade === 'A+' || grade === 'A') return 'success';
  if (grade === 'B+' || grade === 'B') return 'info';
  if (grade === 'C') return 'warning';
  if (grade === 'D' || grade === 'F') return 'error';
  return 'default';
};

export const getPerformanceIcon = (studentMark: number, classAverage: number) => {
  if (studentMark >= classAverage * 1.1) return 'high';
  if (studentMark < classAverage * 0.8) return 'low';
  return 'average';
};
